import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Hitos',
    href: '#hitos'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'Noticias',
    href: '#noticias'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-bone/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-245">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-246">
        <a href="#inicio" className="flex items-center" aria-label="TEFOS · Inicio" data-id="element-247">
          <img src="https://cdn.magicpatterns.com/uploads/krogWKC6bDwbBogQ4HpBCV/TEFOS_LOGO.png" alt="TEFOS — El bosque es futuro" className={`h-9 md:h-10 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-248" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-249">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wide transition-colors hover:text-clay ${isScrolled ? 'text-charcoal' : 'text-bone/90'}`} data-id="element-250">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-251">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-charcoal' : 'text-bone'} data-id="element-252" /> : <Menu className={isScrolled ? 'text-charcoal' : 'text-bone'} data-id="element-253" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-254">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-bone shadow-lg md:hidden flex flex-col" data-id="element-255">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="px-6 py-4 text-charcoal font-medium border-b border-bone-dark" data-id="element-256">
                {link.name}
              </a>)}
          </motion.div>}
      </AnimatePresence>
    </header>;
}